const DAY_MS = 24 * 60 * 60 * 1000;

/** Deadline copy: "Final deadline: May 10th" is how Veritant states it publicly. */
export function formatDeadline(iso: string): string {
  const date = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(date.getTime())) return iso;

  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export interface IDeadlineState {
  label: string;
  daysLeft: number;
  hasPassed: boolean;
  /** Inside two weeks — worth calling out rather than stating flatly. */
  isClosing: boolean;
}

export function deadlineState(iso: string, now = new Date()): IDeadlineState {
  const date = new Date(`${iso}T23:59:59`);
  const daysLeft = Math.ceil((date.getTime() - now.getTime()) / DAY_MS);

  return {
    label: formatDeadline(iso),
    daysLeft,
    hasPassed: daysLeft < 0,
    isClosing: daysLeft >= 0 && daysLeft <= 14
  };
}

/** Shared date rendering so drafts, submissions and receipts read the same. */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

/** An instant as the day it falls on, spelled out — "March 14, 2027" — for a deadline said in a
 *  sentence, where a time of day would be noise. */
export function formatDay(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}
